export const PURGE_MIN_COUNT = 1;
export const PURGE_MAX_COUNT = 1;
export const MERGE_PURGE_MIN_COUNT = 2;
export const MERGE_PURGE_MAX_COUNT = 2;
